var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglefinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151.921875 214 L 329 214 L 329 521 L 151.921875 521 Z M 151.921875 214 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 651.847656 320.574219 L 410.707031 320.574219 L 410.707031 420.527344 L 549.511719 420.527344 C 536.570312 484.023438 482.460938 520.480469 410.707031 520.480469 C 326.015625 520.480469 257.789062 452.277344 257.789062 367.609375 C 257.789062 282.941406 326.015625 214.738281 410.707031 214.738281 C 447.171875 214.738281 480.109375 227.675781 505.988281 248.839844 L 581.269531 173.582031 C 535.394531 133.601562 476.582031 108.90625 410.707031 108.90625 C 267.199219 108.90625 151.921875 224.148438 151.921875 367.609375 C 151.921875 511.070312 267.199219 626.3125 410.707031 626.3125 C 540.101562 626.3125 657.730469 532.238281 657.730469 367.609375 C 657.730469 352.324219 655.378906 335.859375 651.847656 320.574219 Z M 651.847656 320.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151.921875 108 L 657.730469 108 L 657.730469 368 L 151.921875 368 Z M 151.921875 108 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 651.847656 320.574219 L 410.707031 320.574219 L 410.707031 420.527344 L 549.511719 420.527344 C 536.570312 484.023438 482.460938 520.480469 410.707031 520.480469 C 326.015625 520.480469 257.789062 452.277344 257.789062 367.609375 C 257.789062 282.941406 326.015625 214.738281 410.707031 214.738281 C 447.171875 214.738281 480.109375 227.675781 505.988281 248.839844 L 581.269531 173.582031 C 535.394531 133.601562 476.582031 108.90625 410.707031 108.90625 C 267.199219 108.90625 151.921875 224.148438 151.921875 367.609375 C 151.921875 511.070312 267.199219 626.3125 410.707031 626.3125 C 540.101562 626.3125 657.730469 532.238281 657.730469 367.609375 C 657.730469 352.324219 655.378906 335.859375 651.847656 320.574219 Z M 651.847656 320.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151.921875 108 L 657.730469 108 L 657.730469 626.3125 L 151.921875 626.3125 Z M 151.921875 108 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 651.847656 320.574219 L 410.707031 320.574219 L 410.707031 420.527344 L 549.511719 420.527344 C 536.570312 484.023438 482.460938 520.480469 410.707031 520.480469 C 326.015625 520.480469 257.789062 452.277344 257.789062 367.609375 C 257.789062 282.941406 326.015625 214.738281 410.707031 214.738281 C 447.171875 214.738281 480.109375 227.675781 505.988281 248.839844 L 581.269531 173.582031 C 535.394531 133.601562 476.582031 108.90625 410.707031 108.90625 C 267.199219 108.90625 151.921875 224.148438 151.921875 367.609375 C 151.921875 511.070312 267.199219 626.3125 410.707031 626.3125 C 540.101562 626.3125 657.730469 532.238281 657.730469 367.609375 C 657.730469 352.324219 655.378906 335.859375 651.847656 320.574219 Z M 651.847656 320.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281 214 L 657.730469 214 L 657.730469 626.3125 L 281 626.3125 Z M 281 214 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 651.847656 320.574219 L 410.707031 320.574219 L 410.707031 420.527344 L 549.511719 420.527344 C 536.570312 484.023438 482.460938 520.480469 410.707031 520.480469 C 326.015625 520.480469 257.789062 452.277344 257.789062 367.609375 C 257.789062 282.941406 326.015625 214.738281 410.707031 214.738281 C 447.171875 214.738281 480.109375 227.675781 505.988281 248.839844 L 581.269531 173.582031 C 535.394531 133.601562 476.582031 108.90625 410.707031 108.90625 C 267.199219 108.90625 151.921875 224.148438 151.921875 367.609375 C 151.921875 511.070312 267.199219 626.3125 410.707031 626.3125 C 540.101562 626.3125 657.730469 532.238281 657.730469 367.609375 C 657.730469 352.324219 655.378906 335.859375 651.847656 320.574219 Z M 651.847656 320.574219 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M 128.398438 520.480469 L 128.398438 214.738281 L 328.367188 367.609375 Z M 128.398438 520.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M 128.398438 214.738281 L 328.367188 367.609375 L 410.707031 295.878906 L 693.019531 250.019531 L 693.019531 85.390625 L 128.398438 85.390625 Z M 128.398438 214.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M 128.398438 520.480469 L 481.285156 250.019531 L 574.214844 261.777344 L 693.019531 85.390625 L 693.019531 649.828125 L 128.398438 649.828125 Z M 128.398438 520.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M 693.019531 649.828125 L 328.367188 367.609375 L 281.316406 332.332031 L 693.019531 214.738281 Z M 693.019531 649.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglefinal);
export default __webpack_public_path__ + "static/media/googlefinal.10d00a48cb0dc020fe8e23ec3f67d8fb.svg";
export { ForwardRef as ReactComponent };